import { styled, Typography } from '@mui/material';

export const SectionTitle = styled(Typography)(({ theme }) => ({
  fontSize: theme.hhglobal.typography.headings.h2.fontSize,
  fontWeight: theme.hhglobal.typography.fontWeights.bold,
  lineHeight: theme.hhglobal.typography.headings.h1.lineHeight,
  marginBottom: theme.hhglobal.spacing.spacing[2].valuePx,
  color: theme.hhglobal.neutral.superblack,
})) as typeof Typography;
